module.exports = __webpack_public_path__ + "img/confirmation-icon.e152307e.svg";